import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Recruiter, RecruiterList} from '../model/recruiter.model';
import {StudiesService} from '../../shared/services/studies.service';
import { LoginService } from 'src/app/services/login.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-assign-recruiter',
  templateUrl: './assign-recruiter.component.html',
  styleUrls: ['./assign-recruiter.component.scss']
})
export class AssignRecruiterComponent implements OnInit {

  @Input() recruiterList: RecruiterList;
  @Input() studyId: any;
  @Input() placeholder: string;
  public recruiter: Recruiter;
  selectedRecruiter:any = [];
  @Output() close: EventEmitter<any> = new EventEmitter();
  formStatus=true;
  statusClass: any;
  responseIcon: any;
  responseMessage: any;

  constructor(private studiesService: StudiesService, private logerror: LoginService, private router: Router) { }


  ngOnInit() {
    this.placeholder = 'select Recruiter';
    this.recruiter = new Recruiter({
      recruiter_name: '', phone: '', employee_id: '', recruiter_code: '',location:''
    });
    let splitStr = this.studyId;
    this.studyId = splitStr.split('?')[0];
  }

  selectedRecruiterHandler($event: any) {
    this.selectedRecruiter = $event;
  }

  onClose(){
    this.close.emit();
  }
  onAssign(){
    this.formStatus=true;

    const selectedRecruiterId = [];
    this.selectedRecruiter.filter(recruiter=>selectedRecruiterId.push(recruiter.id));
    const payload = {
      study:this.studyId,
      recruiter_id:selectedRecruiterId.toString()
    }
    this.studiesService.assignStudyToMultipleRecruiter(payload).subscribe(data=>{

      if ( data.responseCode == 1){
        this.formStatus=true;
        this.statusClass = 'success';
        this.responseIcon ='check_circle_outline';
        this.responseMessage = 'You have successfully update';
      }
      else{
        this.formStatus = true;
        this.statusClass = 'fail';
        this.responseIcon ='error_outline';
        this.responseMessage = 'Oops ! Some error occur.'

      }
    },
    error=>{
      if(error.status == 401){
        this.router.navigate(['home/access-denied']);
      }
    })
  }



}
